// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
  display: block;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  border: 1px solid white;
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 15px;
}

.plantaddButton {
  text-align: center;
}
.FormContainer {
  background-color: #282b30;
}

.budget button {
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  border-radius: 0;
  color: #eee;
  margin-left: 10px;
  text-align: center;
  float: right;
}
.addNewProject {
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  border-radius: 0 !important;
  color: #eee;
  margin-left: 10px;
  text-align: center;
  font-size: 10px;
}
.addNewProject:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}
.inline{
  display: grid;
  width: 95%;
  margin-bottom: 5px;
}
.inlinetextarea{
  display: grid;
  width: 98%;
  margin-bottom: 5px;
}

.inline input{
  border-radius: 0 !important;
  background-color: #131322 !important;
  color: #eee !important;
}
.cancelBudgetProject{
  float: right;
  width: 100px;
  background-color: #9a9b9c;
  border-radius: 0 !important;
  text-align: center;
  margin-right: 10px;
}
.cancelBudgetProject:hover{
  background-color: #7d7e80
  ;
}
.submitBudgetProject{
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  border-radius: 0;
  color: #eee;
  width: 100px;
  text-align: center;
  margin-left: 5px;
  
}
.submitBudgetProject:hover{
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
  
}
.inlinetextarea .css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root{
  width: 100% !important;
  border: 1px solid #eee !important;
  border-radius: 0 !important;
  color: #eee !important;
  margin-bottom: 15px;
  min-height: 150px;
}
.inputContainers{
  width: 95%;
  display: flex;
  flex-direction: column;
  border-radius: 0 !important;
}
.inputContainers .css-1e08a1-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{
  border-radius: 0 !important;
}
.inputContainers input{
  border-radius: 0 !important;
  background-color: #131322 !important;
  color: #eee !important;
}

.budget button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}
.fieldswrapper {
  width: fit-content;
  background-color: #131322;
  margin: 5px;
  padding: 5px;
}

.fieldswrappers {

  background-color: #131322;
  margin: 5px;
  padding: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/ReportHistory/budgetForm.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;;;GAIC;EACD,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;;;;GAIC;EACD,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;;;;GAIC;AACH;AACA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;EACA;AACF;AACA;EACE;;;;GAIC;EACD,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;;AAElB;AACA;EACE;;;;GAIC;;AAEH;AACA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE;;;;GAIC;AACH;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf","sourcesContent":["input {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  border-radius: 4px;\n  border: 1px solid white;\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  font-size: 15px;\n}\n\n.plantaddButton {\n  text-align: center;\n}\n.FormContainer {\n  background-color: #282b30;\n}\n\n.budget button {\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  border-radius: 0;\n  color: #eee;\n  margin-left: 10px;\n  text-align: center;\n  float: right;\n}\n.addNewProject {\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  border-radius: 0 !important;\n  color: #eee;\n  margin-left: 10px;\n  text-align: center;\n  font-size: 10px;\n}\n.addNewProject:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n.inline{\n  display: grid;\n  width: 95%;\n  margin-bottom: 5px;\n}\n.inlinetextarea{\n  display: grid;\n  width: 98%;\n  margin-bottom: 5px;\n}\n\n.inline input{\n  border-radius: 0 !important;\n  background-color: #131322 !important;\n  color: #eee !important;\n}\n.cancelBudgetProject{\n  float: right;\n  width: 100px;\n  background-color: #9a9b9c;\n  border-radius: 0 !important;\n  text-align: center;\n  margin-right: 10px;\n}\n.cancelBudgetProject:hover{\n  background-color: #7d7e80\n  ;\n}\n.submitBudgetProject{\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  border-radius: 0;\n  color: #eee;\n  width: 100px;\n  text-align: center;\n  margin-left: 5px;\n  \n}\n.submitBudgetProject:hover{\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n  \n}\n.inlinetextarea .css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root{\n  width: 100% !important;\n  border: 1px solid #eee !important;\n  border-radius: 0 !important;\n  color: #eee !important;\n  margin-bottom: 15px;\n  min-height: 150px;\n}\n.inputContainers{\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0 !important;\n}\n.inputContainers .css-1e08a1-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{\n  border-radius: 0 !important;\n}\n.inputContainers input{\n  border-radius: 0 !important;\n  background-color: #131322 !important;\n  color: #eee !important;\n}\n\n.budget button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n.fieldswrapper {\n  width: fit-content;\n  background-color: #131322;\n  margin: 5px;\n  padding: 5px;\n}\n\n.fieldswrappers {\n\n  background-color: #131322;\n  margin: 5px;\n  padding: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
